<div class="all">
  <div class="center-container">
    <img src="assets/logo.png" class="logo">
  </div>
</div>
